module.exports = __webpack_public_path__ + "img/logo.9869fc86.svg";